import React from "react";
import { motion } from "framer-motion";
import homeLogo from "../../Assets/home-main.svg";
import Home2 from "./Home2";
import Type from "./Type";

function Home() {
  return (
    <section className="relative min-h-screen text-white overflow-hidden">
      <div className="relative z-10 container mx-auto px-4 md:px-8 pt-32 pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {/* Left Column: Text Content */}
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="lg:col-span-7 space-y-6"
          >
            <div className="inline-block px-4 py-1 rounded-full glass border-neon/20 text-neon text-sm font-mono tracking-wider mb-4 neon-glow">
              FRONTEND & FULLSTACK DEVELOPER
            </div>
            
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight font-manrope">
              Hi There! <span className="animate-bounce inline-block">👋🏻</span>
              <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-neon leading-normal">
                I'm Vijay Benal
              </span>
            </h1>

            <div className="text-2xl md:text-4xl text-neutral-400 font-medium h-16">
              <Type />
            </div>

            <p className="text-lg text-neutral-400 max-w-xl leading-relaxed">
              Crafting premium digital experiences through purposeful design and 
              performant code. Specialist in modern web ecosystems.
            </p>

            <div className="flex flex-wrap gap-4 pt-4">
              <motion.button 
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="px-8 py-3 bg-primary rounded-xl font-bold text-lg hover:shadow-[0_0_20px_rgba(205,95,248,0.4)] transition-all"
              >
                View My Work
              </motion.button>
              <motion.button 
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="px-8 py-3 glass rounded-xl font-bold text-lg border-white/10 hover:bg-white/10 transition-all text-neutral-300"
              >
                Contact Me
              </motion.button>
            </div>
          </motion.div>

          {/* Right Column: Hero Image / 3D Placeholder */}
          <motion.div 
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, ease: "easeOut" }}
            className="lg:col-span-5 relative"
          >
            <div className="relative group">
              <div className="absolute -inset-1 bg-gradient-to-r from-primary to-neon rounded-full blur opacity-20 group-hover:opacity-40 transition duration-1000 group-hover:duration-200"></div>
              <img
                src={homeLogo}
                alt="home pic"
                className="relative w-full max-w-[500px] mx-auto filter drop-shadow-[0_0_50px_rgba(205,95,248,0.2)]"
              />
            </div>
          </motion.div>
        </div>
      </div>
      <Home2 />
    </section>
  );
}

export default Home;
